<script lang="ts">
  import { browser } from '$app/environment';

  import DropdownList from '$shared/atoms/DropdownList/DropdownList.svelte';

  interface Props {
    list?: CommonList[];
    show?: boolean;
    alignRight?: boolean;
    hasOverflow?: boolean;
    children?: import('svelte').Snippet;
    onclick?: (item: CommonList) => void;
    onclose?: () => void;
  }

  let {
    list = [],
    show = false,
    alignRight = false,
    hasOverflow = false,
    children,
    onclick,
    onclose
  }: Props = $props();

  let parent: HTMLElement = $state();
  let labelElement: HTMLElement = $state();
  let listElement: HTMLElement = $state();

  const onClickWindow = (e: any) => {
    if (parent && !parent.contains(e.target)) {
      onclose?.();
      removeScrollEventListner();
    }
  };

  const addScrollEventListener = (): void => {
    browser && window.addEventListener('svelte-scroll', () => setPosition());
  };

  const removeScrollEventListner = (): void => {
    browser && window.removeEventListener('svelte-scroll', () => setPosition());
  };

  const calculatePosition = (dimension: DOMRect): { x: number; y: number } => {
    let x = 0;
    let y = 0;
    if (dimension) {
      const dropdownListDim = listElement?.getBoundingClientRect();
      x = dimension.left + dimension.width - (dropdownListDim?.width || 0);
      y = dimension.top + dimension.height + 8;
    }

    return { x, y };
  };

  const setPosition = (): void => {
    const dim = labelElement?.getBoundingClientRect();
    if (!dim) return;

    const { x, y } = calculatePosition(dim);
    listElement.style.top = y + 'px';
    listElement.style.left = x + 'px';
  };

  export const setScrollListener = (): void => {
    if (!hasOverflow) return;
    addScrollEventListener();
    setPosition();
  };
</script>

<svelte:window onmouseup={onClickWindow} />

<div bind:this={parent} class="comp-with-list" class:alignRight>
  <div bind:this={labelElement} class="label">
    {@render children?.()}
  </div>
  {#if list.length !== 0}
    <div bind:this={listElement} class="list" class:show class:fixed={hasOverflow}>
      <DropdownList maxheight {list} {onclick} />
    </div>
  {/if}
</div>

<style>
  .comp-with-list {
    position: relative;
  }
  .comp-with-list.alignRight .list {
    left: 0;
    right: auto;
  }
  .list {
    display: none;
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 99;
  }
  .list.fixed {
    position: fixed;
    right: unset;
  }
  .list.show {
    display: block;
  }
</style>
